import { Image } from 'dma-ui-kit';

const Sponsor = props => {
    const { attributes, relationships } = props.paragraph;

    const title = attributes.field_title;
    const url = attributes.field_url;
    const src = relationships.field_media.data[0].relationships.field_media_image.data.attributes.uri.url;

    return (
        <>
            <a href={url} target={'_blank'}>
                <Image src={src} alt={title} />
            </a>
        </>
    );
};

export default Sponsor;
